import axios from 'axios'

function initialState() {
  return {
    userList: [],
    roleList: [],
    allContinuousDataStations: [],
    continuousDataStations: [],
    discreteSampleStations: [],
    continuousDataStationDetail: [],
    synchronizing: false,
    synCompleted: false,
    syncrhonizeMessage: '',
    allMediaTypeList: [],
  }
}

export default {
  namespaced: true,

  state: initialState,

  actions: {
    getUserList({ commit }, params = null) {
      let url = 'api/Account/Users'

      return axios.get(url, {
        params,
      })
        .then(res => {
          commit('SET_UserList', res.data)
        })
        .catch(() => {
          console.log('Could not get user data from \'' + url + '\'')
        })
    },
    async getRoleList({ commit }) {
      let url = 'api/AdminUserGroup/List'
      try {
        new Promise((resolve, reject) => {
          axios.get(url)
            .then(res => {
              let data
              resolve(data = res.data.sort((a, b) => (a.RoleName > b.RoleName ? 1 : -1)) || [])
              commit('SET_RoleList', data)
            }).catch(err => {
              reject(err.data)
            })
        })
      } catch (e) {
        console.log('Could not get user data from \'' + url + '\'')
      }
    },
    getUsersDetail(_, userIds) {
      let url = 'api/Account/UsersDetail'
      return axios.post(url, userIds)
        .then(response => {
          return response.data
        })
        .catch(error => {
          console.error(error)
          throw error.response.data
        })
    },
    async postEditUserDetail({
      commit,
    }, options) {
      axios.post('api/Account/UpdateUserAccountDetail', options.data)
        .then(res => {
          commit('EditUserDetail', options.data)
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async postEditUserPassword({
      commit,
    }, options) {
      axios.post('api/Account/UpdatePassword', options.data)
        .then(res => {
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async postAddUser({
      commit,
    }, options) {
      axios.post('api/Account/Register', options.data)
        .then(res => {
          commit('AddUser', options.data)
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async postDeleteUser({
      commit,
    }, options) {
      axios.post('api/Account/DeleteUser', options.data)
        .then(res => {
          commit('DeleteUser', options.data)
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async postAddRole({
      commit,
    }, options) {
      axios.post('api/AdminUserGroup/Create', options.data)
        .then(res => {
          commit('AddRole', res.data)
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async postDeleteRole({ commit }, options) {
      axios.delete('api/AdminUserGroup/Delete', { data: options.data })
        .then(res => {
          commit('DeleteRole', options.data)
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async getAllContinuousDataStationsList({ commit }, options) {
      let url = 'api/AdminUserGroup/ContinuousStationAccess/List/' + options
      try {
        axios.get(url)
          .then(res => {
            commit('SET_AllContinuousDataStations', res.data)
          })
      } catch (e) {
        console.log('Could not get user data from \'' + url + '\'')
      }
    },
    async getContinuousDataStationDetail({ commit }, options) {
      let url = 'api/AdminUserGroup/ContinuousStationAccess/Detail/' + options.data1 + '/' + options.data2
      try {
        axios.get(url)
          .then(res => {
            commit('SET_ContinuousDataStationDetail', res.data)
            options.successCb(res)
          })
      } catch (e) {
        console.log('Could not get user data from \'' + url + '\'')
      }
    },
    async postAddContinuousStationLink({
      commit,
    }, options) {
      axios.post('api/AdminUserGroup/ContinuousStationAccess/Link/Add', options.data)
        .then(res => {
          options.successCb(res)
          commit('SET_ContinuousDataStationDetail', res.data.AccessInfo)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async postUnlinkContinuousStation({
      commit,
    }, options) {
      axios.post('api/AdminUserGroup/ContinuousStationAccess/Link/Unlink', options.data)
        .then(res => {
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async postAddDiscreteStation({
      commit,
    }, payload) {
      try {
        let res = await axios.post('api/AdminUserGroup/AddDiscreteStation', payload)
        commit('AddDiscreteSampleStation', payload)
        return res.data
      } catch (error) {
        throw error.response.data
      }
    },
    async postDeleteDiscreteStation({
      commit,
    }, options) {
      axios.post('api/AdminUserGroup/DeleteDiscreteStation', options.data)
        .then(res => {
          options.successCb(res)
          commit('DeleteDiscreteSampleStation', options.data)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async getContinuousDataStations({ commit }, options) {
      try {
        var res = await axios.get('/api/LocationAPI/Get/' + options)
        var mappedData = res.data.map(m => {
          return {
            id: m.Id,
            name: m.LocationIdentifier,
            sampleType: 'continuous',
            locationType: m.LocationType,
            description: m.LocationDescription,
            medias: [],
            synonyms: [],
            position: {
              lat: m.Latitude,
              lng: m.Longitude,
            },
          }
        })
        commit('ContinuousDataStations', mappedData)
      } catch (e) {
        console.log('Could not get user data from /api/LocationAPI/Get')
      }
    },
    async postUpdateContinuousStationLinkTag({ commit }, options) {
      try {
        const res = await axios.post('api/Tag/set', options)
        commit('UpdateContinuousStationLinkTag', res.data)
      } catch (err) {
        console.log('Could not get user data from \'api/Tag/set\'', err)
      }
    },
    async getDiscreteSampleStations({ commit }, options) {
      let url = '/api/WaterQuality/Location/List/' + options.data
      try {
        await axios.get(url)
          .then(res => {
            options.successCb(res)
            var mappedData = res.data.filter(x => x.LocationType != 'QAQC').map(m => {
              return {
                id: m.Id,
                name: m.LocationIdentifier,
                sampleType: 'discrete',
                locationType: m.LocationType,
                description: m.LocationDescription,
                medias: m.LocationType != null ? [m.LocationType] : ['Unknown'],
                synonyms: m.Synonyms,
                position: {
                  lat: m.Latitude,
                  lng: m.Longitude,
                },
              }
            })
            commit('DiscreteSampleStations', mappedData)
          })
      } catch (e) {
        console.log('Could not get water quality data from \'' + url + '\'')
      }
    },
    async synchronizeAquariusDatabase({ commit }) {
      commit('SET_SYNCHRONIZE_STATUS', true)
      commit('SET_SYNCHRONIZE_COMPLETED', false)
      commit('SET_SYNCHRONIZE_MESSAGE', 'Synchronization in progress, please do not close the dialog.')
      setTimeout(() => {
        commit('SET_SYNCHRONIZE_STATUS', false)
        commit('SET_SYNCHRONIZE_COMPLETED', true)
        commit('SET_SYNCHRONIZE_MESSAGE', 'Synchronization complete!')
      }, 5000)
      //let url = '/api/AdminAPI/Sync'
      // try {
      //   await axios.post(url)
      //   .then(() => {
      //     commit('SET_SYNCHRONIZE_STATUS', false)
      //     commit('SET_SYNCHRONIZE_COMPLETED', true)
      //     commit('SET_SYNCHRONIZE_MESSAGE', 'Synchronization complete!')
      //   })
      // } catch (e) {
      //   commit('SET_SYNCHRONIZE_STATUS', false)
      //   commit('SET_SYNCHRONIZE_MESSAGE', 'Synchronization failed, please try again or contact the EIS group.')
      // }
    },
    async getUserGroupSideMenuSetting({ commit }, options) {
      let url = 'api/UserGroupSetting/UserGroup/' + options.data
      try {
        const res = await axios.get(url)
        options.successCb(res)
      } catch (e) {
        console.log('Could not get water quality data from \'' + url + '\'', e)
      }
    },
    async postUpdateUserGroupSideMenuSetting({ commit }, options) {
      return await axios.post('api/UserGroupSetting/Update', options.data)
    },
    async getMediaTypeList({ commit }) {
      let url = 'api/MediaTypes/List'
      try {
        const res = await axios.get(url)
        commit('SET_MediaTypeList', res.data)
      } catch (e) {
        console.log('Could not get media types data from \'' + url + '\'')
        throw 'Could not get media types data.'
      }
    },
    async postAddMediaType({ commit }, options) {
      await axios.post('api/MediaTypes/Add', options.data)
        .then(res => {
          commit('AddMediaType', res.data)
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async putUpdateMediaType({ commit }, options) {
      await axios.put('api/MediaTypes/Update', options.data)
        .then(res => {
          commit('UpdateMediaType', res.data)
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
    async deleteMediaType({ commit }, options) {
      await axios.delete('api/MediaTypes/Delete/' + options.data)
        .then(res => {
          commit('deleteMediaType', options.data)
          options.successCb(res)
        })
        .catch(error => {
          options.failedCb(error)
        })
    },
  },
  mutations: {
    RESET(state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    SET_UserList: (state, data) => state.userList = data,
    //Get the tenant list
    SET_RoleList: (state, data) => state.roleList = data,
    EditUserDetail(state, data) {
      var dc = JSON.parse(JSON.stringify(state.userList))
      let editUser = dc.find(x => x.UserName == data.UserName)
      editUser.Email = data.Email
      editUser.UserRole = data.NewRole
      editUser.IsTenantAdmin = data.IsTenantAdmin
      editUser.IsSysAdmin = data.IsSysAdmin
      editUser.EnableTwoFactor = data.EnableTwoFactor
      let i = dc.indexOf(editUser)
      dc.splice(i, 1, editUser)
      state.userList = dc
    },
    AddUser(state, data) {
      var dc = JSON.parse(JSON.stringify(state.userList))
      let addUser = {
        Email: data.Email,
        IsLockedOut: false,
        Password: data.Password,
        UserName: data.UserName,
        UserRole: data.Role,
        IsTenantAdmin: data.IsTenantAdmin,
        IsSysAdmin: data.IsSysAdmin,
        EnableTwoFactor: data.EnableTwoFactor,
      }
      dc.push(addUser)
      state.userList = dc
    },
    DeleteUser(state, data) {
      var dc = JSON.parse(JSON.stringify(state.userList))
      let deleteUser = dc.find(x => x.UserName == data.UserName)
      let i = dc.indexOf(deleteUser)
      dc.splice(i, 1)
      state.userList = dc
    },
    AddRole(state, data) {
      var dc = JSON.parse(JSON.stringify(state.roleList))
      let addRole = {
        Id: data.Id,
        RoleName: data.RoleName,
      }
      dc.push(addRole)
      state.roleList = dc
    },
    DeleteRole(state, data) {
      var dc = JSON.parse(JSON.stringify(state.roleList))
      let deleteRole = dc.find(x => x.RoleName == data.RoleName)
      let i = dc.indexOf(deleteRole)
      dc.splice(i, 1)
      state.roleList = dc
    },
    SET_AllContinuousDataStations: (state, data) => state.allContinuousDataStations = data,
    SET_ContinuousDataStationDetail: (state, data) => state.continuousDataStationDetail = data,
    ContinuousDataStations: (state, data) => state.continuousDataStations = data,
    DiscreteSampleStations: (state, data) => state.discreteSampleStations = data,
    AddDiscreteSampleStation(state, data) {
      var dc = JSON.parse(JSON.stringify(state.discreteSampleStations))
      let newStation = {
        id: data.Id,
        medias: [],
        name: data.StationName,
        locationType: data.Type,
      }
      dc.push(newStation)
      state.discreteSampleStations = dc
    },
    DeleteDiscreteSampleStation(state, data) {
      var dc = JSON.parse(JSON.stringify(state.discreteSampleStations))
      let deleteStation = dc.find(x => x.name == data.StationName)
      let i = dc.indexOf(deleteStation)
      dc.splice(i, 1)
      state.discreteSampleStations = dc
    },
    SET_SYNCHRONIZE_STATUS: (state, data) => state.synchronizing = data,
    SET_SYNCHRONIZE_MESSAGE: (state, data) => state.syncrhonizeMessage = data,
    SET_SYNCHRONIZE_COMPLETED: (state, data) => state.synCompleted = data,
    UpdateContinuousStationLinkTag(state, data) {
      var dc = JSON.parse(JSON.stringify(state.continuousDataStationDetail))
      data.forEach(element => {
        var parameter = dc.find(x => x.TimeSeriesId == element.ParameterId)
        let i = dc.indexOf(parameter)
        var param = {
          ...parameter,
          Tags: element.Tags,
        }
        dc.splice(i, 1, param)
      })
      state.continuousDataStationDetail = dc
    },
    SET_MediaTypeList: (state, data) => state.allMediaTypeList = data,
    AddMediaType(state, data) {
      var dc = JSON.parse(JSON.stringify(state.allMediaTypeList))
      dc.push(data)
      state.allMediaTypeList = dc
    },
    UpdateMediaType(state, data) {
      var dc = JSON.parse(JSON.stringify(state.allMediaTypeList))
      let updateType = dc.find(x => x.Id == data.Id)
      let i = dc.indexOf(updateType)
      dc.splice(i, 1, data)
      state.allMediaTypeList = dc
    },
    deleteMediaType(state, data) {
      var dc = JSON.parse(JSON.stringify(state.allMediaTypeList))
      let deleteType = dc.find(x => x.Id == data)
      let i = dc.indexOf(deleteType)
      dc.splice(i, 1)
      state.allMediaTypeList = dc
    },
  },

  getters: {
    'roleList': (state) => state.roleList,
    'tenants': (state) => state.roleList,
    'userList': (state) => state.userList,
    'allContinuousDataStations': (state) => state.allContinuousDataStations,
    'continuousDataStations': (state) => state.continuousDataStations,
    'discreteSampleStations': (state) => state.discreteSampleStations,
    'continuousDataStationDetail': (state) => state.continuousDataStationDetail,
    'synchronizing': (state) => state.synchronizing,
    'syncrhonizeMessage': (state) => state.syncrhonizeMessage,
    'synCompleted': (state) => state.synCompleted,
    'allMediaTypeList': (state) => state.allMediaTypeList,
  },
}